/**
 * Instalment amount for a percentage plan (e.g. 40 of 40:30:30), rounded up to the next shilling.
 * Must match the backend payment schedule, which rejects Paybill payments below the first instalment.
 */
export default function instalmentAmount(totalPremium, percent) {
  const cents = Math.round(Number(totalPremium || 0) * percent);
  return Math.ceil(cents / 100);
}
